import {Notify, Confirm, Loading} from 'vue-ydui/dist/lib.rem/dialog';
import Vue from 'vue'
import {Toast} from 'vant'
import axios from 'axios/index'
import Exif from 'exif-js'
import CallApp from 'callapp-lib'
import Router from '../router'
import wx from 'weixin-js-sdk'

export default {
	// 替换URL为正式环境地址
	repalceURL(url) {
		if (process.env.NODE_ENV === 'development') {
			// return url
			if (url.startsWith('/app')) {
				return 'https://gateway-center-test.xcdtech.net' + url
				// return 'http://172.16.17.7:9100' + url
			} else if (url.startsWith('/xcd')) {
				return 'https://zxpt-test.xcdtech.net' + url
			}
		} else if ((window.location.href).indexOf("test") == -1) {
			// 正式环境
			if (url.startsWith('/app')) {
				return 'https://gateway-center.xcdtech.net' + url
			} else if (url.startsWith('/xcd')) {
				return 'https://gateway-center-gov.xcdtech.net' + url
			}
		} else {
			// 测试环境
			if (url.startsWith('/app')) {
				return 'https://gateway-center-test.xcdtech.net' + url
			} else if (url.startsWith('/xcd')) {
				return 'https://zxpt-test.xcdtech.net' + url
			}
		}
		// return (window.location.href).indexOf("localhost")==-1&&(window.location.href).indexOf("test")==-1 ?'https://gateway-center.xcdtech.net/app':'https://gateway-center-test.xcdtech.net/app',
		// return process.env.NODE_ENV === 'production' ? 'http://mb-service.xcd.yjgonghui.cn:80/credit' + url.replace(/^\/app/, '') : url
	},
	// 提供await请求方式
	promiseRequest: function (url, data) {
		let that = this
		return new Promise((resolve, reject) => {
			that.infoSubmit(url, data, function (data) {
				resolve(data)
			}, function () {
				reject()
			})
		})
	},
	infoSubmit: function (url, data, callback, callback2, timeout) { //数据提交 添加 dkId
		let defaultTime = 10 * 1000
		if (timeout) {
			defaultTime = timeout
		}
		var that = this;
		var postData = data;
		// 用户端才添加,其他端不添加
		if (!localStorage.getItem("loginType")) {
			postData.dkId = localStorage.getItem("dkId");
		}
		axios.post(this.repalceURL(url), postData, {timeout: defaultTime})
			.then(function (res) {
				localStorage.setItem('lastRequestTime', new Date().getTime());
				if (res.data.code == 200) {
					callback(res.data.data);
				} else if (res.data.code == 203) {
					callback2 != null && callback2(res.data.retMsg)
				} else if (res.data.code == 201 || res.data.code == 209) {
					// callback(null, res.data.retMsg);
					callback(res.data.retMsg);
				} else {
					// that.errTip(res.data.message);
					if (callback2) {
						Loading.close()
						// console.log('error message ', res)
						callback2 != null && callback2(res.data.retMsg)
					}
				}
			})
			.catch(function (error) {
				callback2 != null && callback2(error || '连接失败')
				localStorage.setItem('lastRequestTime', new Date().getTime());
				// callback2 != null && callback2(error)
				Loading.close()
				// console.log(error);
				// Toast.fail('连接失败')
				// callback2 != null && callback2(error)
			});
	},
	getData: function (url, data, callback, callback2, timeout) {
		let defaultTime = 10 * 1000
		if (timeout) {
			defaultTime = timeout
		}
		var that = this;
		axios.get(this.repalceURL(url), {params: data, timeout: defaultTime})
			.then(function (res) {
				localStorage.setItem('lastRequestTime', new Date().getTime());
				if (res.data.code != 200) {
					// that.errTip(res.data.message);
					if (callback2) {
						Loading.close()
						callback2(res.data.retMsg)
					}
				} else {
					callback(res.data.data);
				}
			})
			.catch(function (error) {
				localStorage.setItem('lastRequestTime', new Date().getTime());
				if (callback2) {
					Loading.close()
					callback2(error)
				} else {
					// Toast.fail('连接失败')
				}
				// console.log(error);

			});
	},
	getImgUrl(url, data, callback) {
		axios
			.get(this.repalceURL(url), {
				responseType: "arraybuffer",
				params: data
			})
			.then(response => {
				return (
					"data:image/png;base64," +
					btoa(
						new Uint8Array(response.data).reduce(
							(data, byte) => data + String.fromCharCode(byte),
							""
						)
					)
				);
			})
			.then(data => {
				callback(data); //赋值给img标签的src属性
			});
	},
	open: function (url, data, mes, callback) {
		this.loading(mes);
		var that = this;
		axios.post(this.repalceURL(url), data, {
			headers: {
				apikey: "3u99x5hi1es4bjsd0y8at2yrz56s"
			}
		})
			.then(function (res) {
				localStorage.setItem('lastRequestTime', new Date().getTime());
				that.loadingClose();
				if (res.data.status == 200) {
					callback(res.data.data)
				} else {
					callback(res.data)
				}
			})
			.catch(function (error) {
				localStorage.setItem('lastRequestTime', new Date().getTime());
				Loading.close()
				// console.log(error);
				Toast.fail('连接失败')
			});
	},
	openNew: function (url, data, mes, callback) {
		this.loading(mes);
		var that = this;
		axios.post(this.repalceURL(url), data, {
			headers: {
				apikey: "3u99x5hi1es4bjsd0y8at2yrz56s",
				'Content-Type': 'application/json;charset=UTF-8'
			}
		})
			.then(function (res) {
				localStorage.setItem('lastRequestTime', new Date().getTime());
				that.loadingClose();
				if (res.data.code == 200) {
					callback(res.data.data)
				} else {
					callback(res.data)
				}
			})
			.catch(function (error) {
				localStorage.setItem('lastRequestTime', new Date().getTime());
				Loading.close()
				// console.log(error);
				Toast.fail('连接失败')
			});
	},
// 	未认证账号登录 1
// 已认证账号登录 2
// 营业执照OCR（认证前） 3
// 营业执照OCR（认证后） 4
// 法人身份证OCR（认证前） 5
// 法人身份证OCR（认证后） 6
// 个人身份证OCR（认证前） 7
// 个人身份证OCR（认证后） 8
// 活体认证（认证前） 9
// 活体认证（认证后） 10
// 查看贷款产品 11
// 申请贷款产品 12
// 获取授信试算额度 13
// 获取授信额度 14
// 授信支用 15
// 查看政策 16
	getPageEventHandleData: function (data) {
		let sendData = new Object();
		sendData = {
			userId: localStorage.getItem("dkId") || '', //用户ID
			socialCreditCode: data.socialCreditCode || '', //统一社会信用代码
			eventType: data.eventType, //事件类型
			mobilePhone: localStorage.getItem("phoneNum") || '', //手机移动电话号码
			loginIp: localStorage.getItem("cip") || '',//登录IP
			osName: localStorage.getItem("osName") || '',//操作系统
			channelId: 1,//用户渠道：1：微信公众号、2：小程序、3：APP
			openId: localStorage.getItem("openId") || '', //微信OPENID
			unionId: localStorage.getItem("unionId") || '',//微信UNIONID
			deviceId: localStorage.getItem("deviceId") || '',//设备ID （登录手机）
			deviceBrand: localStorage.getItem("deviceBrand") || '',//设备品牌（登录手机）
			deviceMod: localStorage.getItem("deviceMod") || '',//设备型号（登录手机）
			imei: localStorage.getItem("imei") || '',//手机序列号（登录手机）
			gisX: localStorage.getItem("gisX") || '',//地图精度
			gisY: localStorage.getItem("gisY") || '',//地图维度
			productNo: data.productNo || '',//产品编号
		};
		return sendData
	},
	pageEventHandle: function (data) {
		let that = this;
		let sendData = new Object();
		sendData = {
			userId: localStorage.getItem("dkId") || '', //用户ID
			socialCreditCode: data.socialCreditCode || '', //统一社会信用代码
			eventType: data.eventType, //事件类型
			mobilePhone: localStorage.getItem("phoneNum") || '', //手机移动电话号码
			loginIp: localStorage.getItem("cip") || '',//登录IP
			osName: localStorage.getItem("osName") || '',//操作系统
			channelId: 1,//用户渠道：1：微信公众号、2：小程序、3：APP
			openId: localStorage.getItem("openId") || '', //微信OPENID
			unionId: localStorage.getItem("unionId") || '',//微信UNIONID
			deviceId: localStorage.getItem("deviceId") || '',//设备ID （登录手机）
			deviceBrand: localStorage.getItem("deviceBrand") || '',//设备品牌（登录手机）
			deviceMod: localStorage.getItem("deviceMod") || '',//设备型号（登录手机）
			imei: localStorage.getItem("imei") || '',//手机序列号（登录手机）
			gisX: localStorage.getItem("gisX") || '',//地图精度
			gisY: localStorage.getItem("gisY") || '',//地图维度
			productNo: data.productNo || '',//产品编号
		};
		axios.post('/app/event/pageEventHandle', sendData)
			.then(function (res) {
				localStorage.setItem('lastRequestTime', new Date().getTime());
				// console.log(res)
				// localStorage.setItem('firstLogin','');
			})
			.catch(function (error) {
				localStorage.setItem('lastRequestTime', new Date().getTime());
				// console.log(error);
			});
	},
	getJSSDK: function () {
		var url = window.location.href;
		var urlParam = url.split('#')[0];
		let param = {
			"url": urlParam
		}
		this.infoSubmit("/app/weChat/getJSSDK", param, (res) => {
			// console.log(res);
			// console.log('====================');
			wx.config({
				debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
				appId: res.appId, // 必填，公众号的唯一标识
				timestamp: res.timestamp, // 必填，生成签名的时间戳
				nonceStr: res.nonceStr, // 必填，生成签名的随机串
				signature: res.signature,// 必填，签名
				jsApiList: res.jsApiList, // 必填，需要使用的JS接口列表
				openTagList: ['wx-open-launch-weapp'], // 可选，需要使用的开放标签列表
			});
			// console.log('wx.config')
			wx.ready(function () {
				// console.log('wx ready')
				wx.getLocation({
					type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
					success: function (res) {
						// console.log('location success', res)
						var latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
						var longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180
						var speed = res.speed; // 速度，以米/每秒计
						var accuracy = res.accuracy; // 位置精度
						localStorage.setItem("gisX", longitude);
						localStorage.setItem("gisY", latitude);
					},
					fail: function (res) {
						// console.log('location fail', res)
					},
					complete: function (res) {
						// console.log('location complete', res)
						localStorage.setItem("getLocationComplete", 'true');
					}
				});
			});
		}, function () {
			Toast.clear();
		});
	},
	//登录埋点
	loginMd: function () {
		var loginAs = localStorage.getItem('loginAs');
		// console.log('loginAs======'+loginAs)
		if (loginAs != 'youke' && loginAs != 'yonghu') {
			if (localStorage.getItem("dkId")) {
				// console.log('loginMd',)
				//用户登录
				this.infoSubmit("/app/auth/status", {dkId: localStorage.getItem('dkId')}, (res) => {
					// console.log('res',res);
					if (res.status == 0) {
						this.pageEventHandle({eventType: 1});
					} else {
						this.pageEventHandle({eventType: 2});
					}
				}, function () {
					Toast.clear();
				});
				localStorage.setItem('loginAs', 'yonghu');
			} else {
				//游客登录
				this.pageEventHandle({eventType: 1})
				localStorage.setItem('loginAs', 'youke');
			}
		}
	},
	photoCompress: function (file, callback) { //图片压缩
		let self = this;
		let Orientation;
		//去获取拍照时的信息，解决拍出来的照片旋转问题
		Exif.getData(file, function () {
			Orientation = Exif.getTag(this, 'Orientation');
		});
		// 看支持不支持FileReader
		if (!file || !window.FileReader) return;

		if (/^image/.test(file.type)) {
			// 创建一个reader
			let reader = new FileReader();
			// 将图片2将转成 base64 格式
			reader.readAsDataURL(file);
			// 读取成功后的回调
			reader.onloadend = function () {
				// console.log('压缩前 ', this.result.length)
				let result = this.result;
				let img = new Image();
				img.src = result;
				//判断图片是否大于200K,是就直接上传，反之压缩图片
				if (this.result.length <= (100 * 1024 * 2)) {
					callback(this.result);
				} else {
					img.onload = function () {
						let data = self.compress(img, Orientation);
						// console.log('压缩后 ', data.length)
						callback(data);
					}
				}
			}
		}
	},
	compress: function (img, Orientation) { //图片压缩方法
		let canvas = document.createElement("canvas");
		let ctx = canvas.getContext('2d');
		//瓦片canvas
		let tCanvas = document.createElement("canvas");
		let tctx = tCanvas.getContext("2d");
		let initSize = img.src.length;
		let width = img.width;
		let height = img.height;
		//如果图片大于四百万像素，计算压缩比并将大小压至400万以下
		let ratio;
		if ((ratio = width * height / 4000000) > 1) {
			//console.log("大于400万像素")
			ratio = Math.sqrt(ratio);
			width /= ratio;
			height /= ratio;
		} else {
			ratio = 1;
		}
		canvas.width = width;
		canvas.height = height;
		//        铺底色
		ctx.fillStyle = "#fff";
		ctx.fillRect(0, 0, canvas.width, canvas.height);
		//如果图片像素大于100万则使用瓦片绘制
		let count;
		if ((count = width * height / 1000000) > 1) {
			//console.log("超过100W像素");
			count = ~~(Math.sqrt(count) + 1); //计算要分成多少块瓦片
			//            计算每块瓦片的宽和高
			let nw = ~~(width / count);
			let nh = ~~(height / count);
			tCanvas.width = nw;
			tCanvas.height = nh;
			for (let i = 0; i < count; i++) {
				for (let j = 0; j < count; j++) {
					tctx.drawImage(img, i * nw * ratio, j * nh * ratio, nw * ratio, nh * ratio, 0, 0, nw, nh);
					ctx.drawImage(tCanvas, i * nw, j * nh, nw, nh);
				}
			}
		} else {
			ctx.drawImage(img, 0, 0, width, height);
		}
		//修复ios上传图片的时候 被旋转的问题
		if (Orientation != "" && Orientation != 1) {
			switch (Orientation) {
				case 3: //需要180度旋转
					this.rotateImg(img, 'down', canvas);
					break;
				case 6: //需要顺时针（向左）90度旋转
					this.rotateImg(img, 'left', canvas);
					break;
				case 8: //需要逆时针（向右）90度旋转
					this.rotateImg(img, 'right', canvas);
					break;

			}
		}
		//进行最小压缩
		let ndata = canvas.toDataURL('image/jpeg', 0.1);
		tCanvas.width = tCanvas.height = canvas.width = canvas.height = 0;
		return ndata;
	},
	rotateImg: function (img, direction, canvas) {
		//最小与最大旋转方向，图片旋转4次后回到原方向
		const min_step = 0;
		const max_step = 3;
		if (img == null) return;
		//img的高度和宽度不能在img元素隐藏后获取，否则会出错
		let height = img.height;
		let width = img.width;
		let step = 2;
		if (step == null) {
			step = min_step;
		}
		if (direction == 'right') {
			step++;
			//旋转到原位置，即超过最大值
			step > max_step && (step = min_step);
		} else if (direction == 'down') {

		} else {
			step--;
			step < min_step && (step = max_step);
		}
		//旋转角度以弧度值为参数
		let degree = step * 90 * Math.PI / 180;
		let ctx = canvas.getContext('2d');
		switch (step) {
			case 0:
				canvas.width = width;
				canvas.height = height;
				ctx.drawImage(img, 0, 0);
				break;
			case 1:
				canvas.width = height;
				canvas.height = width;
				ctx.rotate(degree);
				ctx.drawImage(img, 0, -height);
				break;
			case 2:
				canvas.width = width;
				canvas.height = height;
				ctx.rotate(degree);
				ctx.drawImage(img, -width, -height);
				break;
			case 3:
				canvas.width = height;
				canvas.height = width;
				ctx.rotate(degree);
				ctx.drawImage(img, -width, 0);
				break;
		}
	},
	errTip: function (msg) {
		Notify({
			mes: "✘  " + msg,
			timeout: 2000
		});
	},
	toast: function (msg, icon) {
		Toast({
			mes: msg,
			timeout: 600,
			icon: icon
		});
	},
	confirm: function (msg, callback) {
		Confirm({
			title: "提示",
			mes: msg,
			opts: [{
				txt: '取消',
				color: false,
			},
				{
					txt: '确定',
					color: "#5A97E8",
					callback: () => {
						callback();
					}
				}
			]
		})
	},
	loading: function (mes) {
		Loading.open(mes);
	},
	loadingClose: function () {
		Loading.close();
	},
	revisePage: function () {
		var u = navigator.userAgent,
			app = navigator.appVersion;
		var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
		if (isIOS) {
			this.blurAdjust();
		}
	},
	blurAdjust: function () {
		setTimeout(() => {
			if (
				document.activeElement.tagName == "INPUT" ||
				document.activeElement.tagName == "TEXTAREA"
			) {
				return;
			}
			let result = "pc";
			if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
				//判断iPhone|iPad|iPod|iOS
				result = "ios";
			} else if (/(Android)/i.test(navigator.userAgent)) {
				//判断Android
				result = "android";
			}
			if ((result = "ios")) {
				document.activeElement.scrollIntoViewIfNeeded(true);
			}
		}, 100);
	},
	nextPage: function (productNo) {
		if (productNo) {
			this.infoSubmit("/app/info/checkStatus", {productNo: productNo}, function (res) {
				if (res) {
					for (var i = 0; i < res.length; i++) {
						for (var key in res[i]) {
							if (res[i][key] == 0) {
								Router.push(({path: '/' + key, query: {productNo: productNo}}))
								return;
							}
						}
					}
					Router.push(({path: "/success", query: {productNo: productNo}}))
				}
			});
		} else {
			Router.go(-1);
		}
	},
	randomFrom: function (lowerValue, upperValue) {
		return Math.floor(Math.random() * (upperValue - lowerValue + 1) + lowerValue);
	},
	// 文本框最多输入两位小数点，限制只能输入正整数
	clearNoNum: function (value, number) {
		if (number == null) {
			number = 6
		}
		// value = value.replace(/[^\d.]/g, "");  //清除“数字”和“.”以外的字符
		// value = value.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
		// value = value.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
		// value = value.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3');//只能输入两个小数
		// if (value.indexOf(".") < 0 && value != "") {//以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
		//   value = parseFloat(value);
		// }
		// return value
		value = value.replace(/^0*(0\.|[1-9])/, "$1");
		value = value.replace(/[^\d.]/g, ""); //清除"数字"和"."以外的字符
		value = value.replace(/^\./g, ""); //验证第一个字符是数字而不是字符
		value = value.replace(/\.{1,}/g, "."); //只保留第一个.清除多余的
		value = value
			.replace(".", "$#$")
			.replace(/\./g, "")
			.replace("$#$", ".");
		value = value.replace(/^(\-)*(\d*)\.(\d\d).*$/, "$1$2.$3"); //只能输入两个小数
		value =
			value.indexOf(".") > 0
				? value.split(".")[0].substring(0, number) + "." + value.split(".")[1]
				: value.substring(0, number);
		return value;
	},
	// 产品详情跳转逻辑, 是否跳详情, 是否跳第三方
	productDetailJump(value) {
		let that = this
		if (value.productNature == 1) {
			// localStorage.setItem("shisuanBack", window.location.href);
			//   this.$router.replace({
			//     path: "/financingDetail",
			//     query: { productNo: value.productNo, status: value.status, productNature: value.productNature},
			//   });
			// 第三方产品
			this.infoSubmit(
				"/app/auth/status",
				{dkId: localStorage.getItem("dkId")},
				(res) => {
					if (res.status == 0) {
						//未认证
						localStorage.setItem('isFirst', '')
						localStorage.setItem("livingToPage", window.location.href);
						// _this.$refs.popup.isPageShow = true;
						return false
					} else {
						// console.log(value)
						//已认证
						// 判断产品是否为纳税e贷，如果是就判断该账号是否有xcd公司主体
						if (value.productName == "纳税e贷") {
							// this.productClick(value);
							this.infoSubmit('/app/check/routePage', {
								dkId: localStorage.getItem("dkId"),
								productNo: value.productNo
							}, (res) => {
								if (res.isSkip !== "0") {
									localStorage.setItem('creditAmount', res.creditAmount)
									Router.replace({
										path: '/agriculturalBank'
									})
								} else {
									if (value.status == 7) {
										value.dkId = localStorage.getItem("dkId")
										that.getProjectUrl(value, "shenqing");
									} else {
										that.getProjectUrl(value, "yongkuan");
									}
								}
							})
						} else {
							if (value.status == 7) {
								value.dkId = localStorage.getItem("dkId")
								that.getProjectUrl(value, "shenqing");
							} else {
								that.getProjectUrl(value, "yongkuan");
							}
						}
						// localStorage.setItem("shisuanBack", window.location.href);
						// this.$router.replace({
						//   path: "/financingDetail",
						//   query: { productNo: value.productNo, status: value.status, productNature: value.productNature},
						// });
					}
				}
			);
		} else if (value.productNature == 3) {
			// 外链产品url
			location.replace(value.thirdProductLink);
		} else {
			//自营产品
			localStorage.setItem("shisuanBack", window.location.href);
			Router.replace({
				path: "/financingDetail",
				query: {
					productNo: value.productNo,
					status: value.status,
					productNature: value.productNature,
					suggestedIdentity: value.suggestedIdentity,
					suggestedType: value.suggestedType,
				},
			});
		}
	},
	// 获取当前时间
	getNowTime: function () {
		let dateTime
		let yy = new Date().getFullYear()
		let mm = new Date().getMonth() + 1
		let dd = new Date().getDate()
		let hh = new Date().getHours()
		let mf = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes()
			:
			new Date().getMinutes()
		let ss = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds()
			:
			new Date().getSeconds()
		dateTime = yy + '-' + mm + '-' + dd + ' ' + hh + ':' + mf + ':' + ss
		// console.log(dateTime)
		return dateTime
	},

	getProjectUrl: function (vo, typeStr) {
		this.loading('');
		var sendData = new Object();
		sendData.productNo = vo.productNo;
		sendData.dkId = vo.dkId;
		sendData.creditNo = vo.creditNo;
		sendData.authType = vo.authType;
		sendData.uniqueCode = vo.uniqueCode
		if (typeStr == 'shenqing') {
			var eventMap11 = this.getPageEventHandleData({eventType: 11, productNo: vo.productNo});
			sendData.eventMap11 = eventMap11;
			// var eventMap12 = this.getPageEventHandleData({eventType: 12, productNo: vo.productNo});
			// sendData.eventMap12 = eventMap12;
		} else if (typeStr == 'yongkuan') {
			// var eventMap11=this.getPageEventHandleData({eventType: 11, productNo: vo.productNo});
			// sendData.eventMap11=eventMap11;
		}
		;
		this.infoSubmit("/app/product/applyAgentProductAndUrl", sendData, function (res) {
			Loading.close();
			// this.infoSubmit("/app/product/addProductApplyLog",)
			if (res != null && res.length > 0) {
				location.replace(res);
			} else {
				const options = {
					scheme: {
						protocol: 'kccatalog'
					},
					intent: {
						package: '',
						scheme: ''
					},
					appstore: 'https://apps.apple.com/cn/app/农行掌上银行/id515651240',
					yingyongbao: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.android.bankabc',
					fallback: ''
				}
				const callLib = new CallApp(options)
				callLib.open({
					param: '',
					path: ''
				})
			}
		}, error => {
			Toast.fail(error)
		});
	},
	fixBottom: function () {
		let $startY = 0
		let $moveY = 0
		let touchesY = 0
		let viewHeight = 0
		//滚动条是否在顶部
		let isScroll_top = true;
		//滚动条是否在底部
		let isScrill_bottom = false;

		function restoreEvent(event) {
			switch (event.type) {
				case "touchstart" :
					$startY = event.touches[0].clientY;
					break;
				case "touchmove" :
					$moveY = event.touches[0].clientY;
					//滑动距离
					touchesY = $startY - $moveY;
					//滚动条顶部
					if (isScroll_top) {
						if (touchesY < 0) {
							// console.log('---------------------preventDefault  1')
							event.preventDefault();
						} else {
							var scrollWrap = document.getElementById("scrollView");
							// 没有滚动条
							if (scrollWrap.scrollHeight == scrollWrap.clientHeight) {
								// console.log('---------------------preventDefault     2')
								event.preventDefault();
							} else {
								// console.log('---------------------stopPropagation         3   ', touchesY)
								event.stopPropagation();
							}
						}
						//滚动条底部
					} else if (isScrill_bottom) {
						if (touchesY > 0) {
							event.preventDefault();
						} else {
							event.stopPropagation();
						}
					}
					break;
				case "touchend" :
					break;
			}
			// console.log('*****restore isScrill_bottom ', isScrill_bottom)
			// console.log('*****restore isScroll_top ', isScroll_top)
		}

		document.getElementById("scrollView").addEventListener("touchstart", restoreEvent);
		document.getElementById("scrollView").addEventListener("touchmove", restoreEvent);
		document.getElementById("scrollView").addEventListener("touchend", restoreEvent);

		document.getElementById("scrollView").addEventListener("scroll", function () {
			var tabView = document.getElementById("scrollView");
			var contentHeight = tabView.scrollHeight, //内容高度
				scrollTop = tabView.scrollTop; //滚动高度
			viewHeight = tabView.clientHeight;

			if (scrollTop == 0) {
				isScroll_top = true;
				isScrill_bottom = false;
			} else {
				isScroll_top = false;
			}
			if ((scrollTop / (contentHeight - viewHeight)) == 1) {
				isScrill_bottom = true;
				isScroll_top = false;
			} else {
				isScrill_bottom = false;
			}
			// console.log('isScrill_bottom ', isScrill_bottom)
			// console.log('isScroll_top ', isScroll_top)
		});
	},
	// 获取url参数
	getUrlParam(name) {
		let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
		let r = window.location.search.substr(1).match(reg);
		if (r != null) {
			return unescape(r[2]);
		}
		return null;
	},
	// 判断是否是微信环境
	isWeiXin() {
		let ua = window.navigator.userAgent.toLowerCase();
		if (ua.match(/MicroMessenger/i) == 'micromessenger') {
			return true;
		} else {
			return false;
		}
	},

	// talkingData统计平台埋点
	setSpot(sendMsg, logMsg) {
		try {
			// console.log(logMsg)
			window.TDAPP.onEvent(sendMsg, logMsg)
			return true
		} catch (err) {
			// console.log(logMsg + '=>err', err)
			return false
		}
	},

	// 判断是否输入的为数字
	isNumber(value) {         //验证是否为数字
		var patrn = /^(-)?\d+(\.\d+)?$/;
		if (patrn.exec(value) == null || value == "") {
			return false
		} else {
			return true
		}
	},
	/**
	 * 将数值四舍五入(保留2位小数)后格式化成金额形式
	 *
	 * @param num 数值(Number或者String)
	 * @return 金额格式的字符串,如'1,234,567.45'
	 * @type String
	 */
	formatMoney(num) {
		num = num.toString().replace(/\$|\,/g, '');
		if (isNaN(num))
			num = "0";
		let sign = (num == (num = Math.abs(num)));
		num = Math.floor(num * 100 + 0.50000000001);
		let cents = num % 100;
		num = Math.floor(num / 100).toString();
		if (cents < 10)
			cents = "0" + cents;
		for (var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++)
			num = num.substring(0, num.length - (4 * i + 3)) + ',' +
				num.substring(num.length - (4 * i + 3));
		return (((sign) ? '' : '-') + num + '.' + cents);
	}
}



// WEBPACK FOOTER //
// ./src/common/unit.js